module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    style: (_vm.size)
  }, [_c('div', {
    staticClass: "rect",
    class: _vm.reset ? 'drop' : ''
  }, [_c('Decorate'), _vm._v(" "), _c('div', {
    staticClass: "screen"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('Matrix', {
    attrs: {
      "propMatrix": _vm.matrix
    }
  }), _vm._v(" "), _c('Logo', {
    attrs: {
      "cur": _vm.status === 'playing',
      "reset": _vm.reset
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "state"
  }, [_c('Point', {
    attrs: {
      "cur": _vm.status === 'playing',
      "max": _vm.max,
      "point": _vm.points
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.foodLabel))]), _vm._v(" "), _c('Number', {
    attrs: {
      "number": _vm.foodCount
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.wallPassLabel))]), _vm._v(" "), _c('Number', {
    attrs: {
      "number": _vm.wallPass ? 1 : 0,
      "length": 1
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.levelLabel))]), _vm._v(" "), _c('Number', {
    attrs: {
      "number": _vm.speedRun + 1,
      "length": 1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('Music', {
    attrs: {
      "data": _vm.music
    }
  }), _vm._v(" "), _c('Pause', {
    attrs: {
      "data": _vm.pause
    }
  }), _vm._v(" "), _c('Number', {
    attrs: {
      "propTime": true
    }
  })], 1)], 1)], 1)])], 1), _vm._v(" "), _c('Keyboard', {
    attrs: {
      "filling": _vm.filling,
      "wallPass": _vm.wallPass
    }
  }), _vm._v(" "), _c('Guide')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-427a9fc7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 154
// module chunks = 1